import {
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
  TypographyProps
} from '@mui/material';
import { SHIPPING_SECTION_ID } from 'components/pages/user/UserProfile/UserProfile';
import { useNavigate } from 'react-router-dom';
import { UXB_ROUTE_NAMES } from 'supplier-portals/uxbeauty/UXBRouteNames';
import { User } from 'types/User';

export const ShippingDetailsCard: React.FC<{
  userProfile: User;
  switchToCustomDetails: () => void;
}> = ({ userProfile, switchToCustomDetails }) => {
  const address = userProfile.shipping_address;
  const navigate = useNavigate();
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack
          direction="row"
          gap={4}
          alignItems="flex-start"
          justifyContent="space-between"
          flexWrap="wrap" // for mobile
        >
          <Stack gap={1}>
            <Line entries={[address.person_of_contact]} variant="h4" />
            <Line entries={[address.company]} />
            <Line entries={[address.street, address.street_additional]} />
            <Line entries={[address.postal_code, address.city]} />
            <Line entries={[address.country]} />
            <Line entries={[userProfile.phone_number.replace(/[\(\)]/g, '')]} />
            <Button
              sx={{ mt: 0.5 }}
              variant="outlined"
              size="small"
              onClick={() =>
                navigate(
                  `${UXB_ROUTE_NAMES.userProfile}#${SHIPPING_SECTION_ID}`
                )
              }
            >
              Edit default address
            </Button>
          </Stack>

          <Button variant="outlined" onClick={switchToCustomDetails}>
            Use custom address for this request
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

const Line: React.FC<{ entries: string[] } & TypographyProps> = ({
  entries,
  ...restProps
}) =>
  entries.length && (
    <Typography variant="body2" lineHeight="110%" {...restProps}>
      {entries.join(', ')}
    </Typography>
  );
